export default {
  methods: {
    formatNumber(v) {
      return v.toLocaleString();
    }
  }
};
